var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-grouped-threads',{staticClass:"pr-2",attrs:{"threads":_vm.threads},on:{"click":_vm.openThread}})}
var staticRenderFns = []

export { render, staticRenderFns }